module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-tool-menu"
  }, [_c('div', {
    ref: "action",
    staticClass: "action"
  }, [_vm._t("action")], 2), _c('div', {
    ref: "content",
    staticClass: "content",
    class: {
      'active': _vm.$props.active
    }
  }, [_c('div', {
    ref: "trine",
    staticClass: "trine"
  }), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70d45142","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZToolMenu.vue
// module id = 1185
// module chunks = 0